import { alpha, InputLabelProps, TextField, TextFieldProps, Theme } from '@mui/material';
import { OutlinedInputProps } from '@mui/material/OutlinedInput';
import { styled } from '@mui/material/styles';
import React from 'react';
import { tokens } from '@/styles/tokens';

// `HTMLDivElement`, not `any`: MUI's `TextField` forwards its ref to the root element, and
// `shared/**` lints `no-explicit-any` at `error` (the ratchet), which fails the pre-commit hook.
const RedditTextField = styled(
  React.forwardRef<HTMLDivElement, TextFieldProps>((props, ref) => (
    <TextField
      ref={ref}
      slotProps={{
        input: { disableUnderline: true } as Partial<OutlinedInputProps>,
        inputLabel: { shrink: true } as Partial<InputLabelProps>,
      }}
      {...props}
    />
  )),
)(({ theme }: { theme: Theme }) => ({
  '& .MuiFilledInput-root': {
    overflow: 'hidden',
    borderRadius: 12,
    border: '1px solid',
    fontSize: 16,
    fontWeight: 500,
    backgroundColor: '#fff',
    color: alpha(tokens.text.primary, 0.95),
    borderColor: theme.palette.divider, // neutral5
    transition: theme.transitions.create(['border-color', 'background-color', 'box-shadow']),
    '&::before': {
      display: 'none',
    },
    '&::after': {
      display: 'none',
    },
    '& input': {
      padding: '1.875rem 0.75rem 0.5rem',
    },
    '&.Mui-error': {
      backgroundColor: alpha(theme.palette.error.main, 0.1),
      borderColor: theme.palette.error.main,
    },
    '&:hover': {
      backgroundColor: 'transparent',
      borderColor: theme.palette.grey[70],
    },
    '&.Mui-focused': {
      backgroundColor: 'transparent',
      '&:not(.Mui-error)': {
        borderColor: theme.palette.primary.main,
      },
    },
  },
  '& .MuiInputLabel-root': {
    transform: 'none',
    top: 16,
    left: 12,
    '&.Mui-focused': {
      color: alpha(tokens.text.primary, 0.8),
    },
  },
}));

export default RedditTextField;
